import styled from 'styled-components';
import Help from '@lendi-ui/icon/Help';
import { gte } from '@lendi-ui/breakpoint';

export const TooltipHelp = styled(Help)`
  position: relative;
  top: 15px;
`;

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FlexWrap = styled.div`
  display: flex;
  flex-direction: row;
  width: 200px;
`;

export const RadioWrap = styled(Wrap as any)`
  ${gte('desktop')`
    flex-direction: row;
  `}
`;
